import {
  METERED_OVERAGE_CENTS_PER_1K_REQUESTS,
  STARTER_INCLUDED_API_REQUESTS_PER_MONTH,
  includedAPIRequestsForPlan,
} from "@lumora/core";

/**
 * Traffic cost estimates for platform site-manage.
 * Rates come from packages/core hostingBilling.
 * ponytail: list rate ≠ Stripe meter unit until catalog synced; UI is indicative.
 */

/** USD cents per 1,000 API requests (Starter / PAYG overage). */
export const TRAFFIC_CENTS_PER_1K = METERED_OVERAGE_CENTS_PER_1K_REQUESTS;

/** Starter included requests/month before overage. */
export const STARTER_INCLUDED_REQUESTS = STARTER_INCLUDED_API_REQUESTS_PER_MONTH;

export type TrafficCost = {
  requests: number;
  /** If every request billed at list overage rate (no included allotment). */
  listRateCents: number;
  /** Overage only against the given plan's included pool (default Starter). */
  starterOverageCents: number;
  includedRemaining: number;
};

export function estimateTrafficCost(requests: number, plan = "starter"): TrafficCost {
  const n = Math.max(0, Math.floor(requests));
  const included = includedAPIRequestsForPlan(plan);
  const listRateCents = Math.round((n / 1000) * TRAFFIC_CENTS_PER_1K);
  const overage = Math.max(0, n - included);
  const starterOverageCents = Math.round((overage / 1000) * TRAFFIC_CENTS_PER_1K);
  return {
    requests: n,
    listRateCents,
    starterOverageCents,
    includedRemaining: Math.max(0, included - n),
  };
}

/** Share of platform traffic for this tenant (0–1). */
export function platformShare(siteRequests: number, platformTotal: number): number {
  if (platformTotal <= 0) return siteRequests > 0 ? 1 : 0;
  return Math.min(1, Math.max(0, siteRequests / platformTotal));
}

/** Decimal GB (1e9 bytes) with 2 decimals, e.g. 1_500_000_000 -> "1.50 GB". */
export function formatBytesGB(bytes: number): string {
  return `${(Math.max(0, bytes) / 1e9).toFixed(2)} GB`;
}
